import BaseComponent from '../../js/base-component';

export default class RegistrationComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.year = this.refs.year;
        this.email = this.refs.email;
        this.website = this.refs.website;
        this.InputClass = 'is-filled';

        this.onInputChange = this.onInputChange.bind(this);
        this.checkValue = this.checkValue.bind(this);
    }

    static getRequiredRefs(){
        return ['year', 'email', 'website'];
    }

    init(){
        this.year.value = this.get_year();

        this.email.addEventListener('input', this.onInputChange);
        this.website.addEventListener('input', this.onInputChange);
        this.checkValue(this.email);
        this.checkValue(this.website);
        window.addEventListener("pageshow", () => {
            this.element.reset();
        });
    }

    get_year(){
        let date = new Date();
        return date.getFullYear();
    }

    checkValue(elem){
        if(elem.value.length > 0) {
            elem.classList.add(this.InputClass);
        }
    }

    onInputChange(e){
        if(e.target.value.length > 0){
            e.target.classList.add(this.InputClass);
        }else{
            e.target.classList.remove(this.InputClass);
        }
    }

    onWebsiteChange(e){
        if(this.website.value.length >0){
            this.website.classList.add(this.InputClass);
        }
    }

    onDestroy(){
        this.email.removeEventListener('input', this.onInputChange);
        this.website.removeEventListener('input', this.onWebsiteChange);
    }
}
